import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'set',
  version: '1.2.0',
  // This node iterates over input arrays - expressions should use $json to reference current item
  iteratesOverItems: true,
  properties: [
    {
      key: 'mode',
      label: 'Mode',
      type: 'options',
      required: true,
      default: 'manual',
      options: [
        { value: 'manual', name: 'Manual Mapping' },
        { value: 'json', name: 'JSON' },
      ],
    },
    {
      key: 'fields',
      label: 'Fields to Set',
      type: 'fixedCollection',
      typeOptions: {
        multipleValues: true,
      },
      default: {
        values: [
          {
            name: '',
            type: 'string',
            stringValue: '',
          },
        ],
      },
      displayOptions: {
        show: {
          mode: ['manual'],
        },
      },
      fixedCollectionOptions: [
        {
          name: 'values',
          displayName: 'Field',
          values: [
            {
              key: 'name',
              label: 'Field Name',
              type: 'string',
              required: true,
              placeholder: 'e.g., user.name or status',
              description: 'Name of the field to set (supports dot notation for nested fields)',
            },
            {
              key: 'type',
              label: 'Value Type',
              type: 'options',
              required: true,
              default: 'string',
              options: [
                { value: 'string', name: 'String' },
                { value: 'number', name: 'Number' },
                { value: 'boolean', name: 'Boolean' },
                { value: 'json', name: 'JSON' },
                { value: 'expression', name: 'Expression' },
              ],
            },
            {
              key: 'stringValue',
              label: 'Value',
              type: 'string',
              placeholder: 'e.g., {{ $node["Previous"].output.name }}',
              description: 'String value or expression',
              displayOptions: {
                show: {
                  type: ['string'],
                },
              },
            },
            {
              key: 'numberValue',
              label: 'Value',
              type: 'number',
              placeholder: '0',
              description: 'Numeric value',
              displayOptions: {
                show: {
                  type: ['number'],
                },
              },
            },
            {
              key: 'booleanValue',
              label: 'Value',
              type: 'boolean',
              default: false,
              description: 'Boolean value',
              displayOptions: {
                show: {
                  type: ['boolean'],
                },
              },
            },
            {
              key: 'jsonValue',
              label: 'Value',
              type: 'json',
              placeholder: '{ "key": "value" }',
              description: 'JSON object or array',
              displayOptions: {
                show: {
                  type: ['json'],
                },
              },
            },
            {
              key: 'expression',
              label: 'Expression',
              type: 'string',
              placeholder: 'e.g., $json.items[0].name',
              description: 'Path expression to resolve a value',
              displayOptions: {
                show: {
                  type: ['expression'],
                },
              },
            },
          ],
        },
      ],
    },
    {
      key: 'jsonData',
      label: 'JSON Data',
      type: 'json',
      required: true,
      placeholder: '{ "field": "value" }',
      description: 'JSON object with fields to set',
      displayOptions: {
        show: {
          mode: ['json'],
        },
      },
    },
    {
      key: 'keepOnlySet',
      label: 'Keep Only Set Fields',
      type: 'boolean',
      default: false,
      description: 'Remove all fields except the ones being set',
    },
    {
      key: 'dotNotation',
      label: 'Dot Notation',
      type: 'boolean',
      default: true,
      description: 'Allow setting nested fields using dot notation (e.g., "user.name")',
      displayOptions: {
        show: {
          mode: ['manual'],
        },
      },
    },
  ],
};

export default schema;
